import React from 'react'
import { ArrayInput, SimpleFormIterator, useTranslate } from 'react-admin'
import KAccordion from 'ui-shared/accordions/KAccordion'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import LocalizedRichInputText from 'ui-shared/LocalizedFields/LocalizedRichInputText'
import { useFormContext } from 'react-hook-form'
import { MappedEnrichedEvent } from 'services/api/entities/events/types/internal/event-models'

const CustomizationsArrayInput: React.FC = () => {
  const translate = useTranslate()
  const { getValues } = useFormContext<MappedEnrichedEvent>()

  function hasItems() {
    return getValues('customizations')?.length > 0
  }

  return (
    <KAccordion
      accordionTitle={translate('form.headers.customization')}
      shoulDisplayAlertIcon={hasItems()}
      defaultExpanded={hasItems()}
    >
      <ArrayInput source="customizations">
        <SimpleFormIterator disableReordering>
          <LocalizedInputText
            source="name"
            label="form.fields.customizationName"
          />
          <LocalizedRichInputText
            source="description"
            label="form.fields.customizationDescription"
          />
        </SimpleFormIterator>
      </ArrayInput>
    </KAccordion>
  )
}

export default CustomizationsArrayInput
